import React from 'react';
import { arrayforMulti } from './utils';
import MultiSelect from './MultiSelect';

const SelectActivity = ({ activities, onChange, selectedItems }) => {
    const allItems = arrayforMulti(activities);

    return (
        <MultiSelect
            allItems={allItems}
            onChange={onChange}
            selectedItems={selectedItems}
            title="Activities"
        />
    );
};

export default SelectActivity;
